import { render, staticRenderFns } from "./Aftersaleslistcomplete.vue?vue&type=template&id=1778397b&"
import script from "./Aftersaleslistcomplete.vue?vue&type=script&lang=js&"
export * from "./Aftersaleslistcomplete.vue?vue&type=script&lang=js&"
import style0 from "./Aftersaleslistcomplete.vue?vue&type=style&index=0&id=1778397b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1778397b')) {
      api.createRecord('1778397b', component.options)
    } else {
      api.reload('1778397b', component.options)
    }
    module.hot.accept("./Aftersaleslistcomplete.vue?vue&type=template&id=1778397b&", function () {
      api.rerender('1778397b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Urbanwarehouse/Aftersaleslistcomplete.vue"
export default component.exports